export const newTagColorPalette = [
  "#27BBFF33",
  "#FF9F3533",
  "#14CDB733",
  "#7C4FF833",
  "#FF62A433",
  "#9D585833",
  "#FF484833",
];
